import Modal from 'react-modal'
import Scrollbar from 'react-scrollbars-custom';
import { $api } from '@/queryClient';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
Modal.setAppElement('#root');

dayjs.extend(customParseFormat);

type Props = {
  modalStatus: boolean
  closeModal: () => void
}

const ModalHistory: React.FC<Props> = ({
  modalStatus,
  closeModal
}) => {

  const afterOpenModal = () => { };

  const selfClose = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const modalElement = document.querySelector('.swing-in-top-fwd');
    if (modalElement) {
      modalElement.classList.add('swing-out-top-bck');
    }
    // setUrlPath('/')

    setTimeout(() => {
      closeModal();
    }, 300);
  };

  const { data } = $api.useQuery('get', '/api/user/history')

  const histories = [...(data?.payload ?? [])].sort((a, b) =>
    dayjs(b?.create_time, 'HH:mm:ss - DD/MM/YYYY').valueOf() - dayjs(a?.create_time, 'HH:mm:ss - DD/MM/YYYY').valueOf()
  )

  const sourceMap = {
    event_mission: 'Nhận quà từ hoạt động Chuyên Cần Tích Lũy',
    spin: 'Nhận quà từ Vòng quay may mắn',
    special_shop: 'Nhận quà từ Tiếp Sức Tựu Trường',
    mission: 'Nhận quà từ Chào Bạn Mới - Đón Bạn Cũ',
    dream_team: 'Nhận quà từ Tổ Đội Cùng Tiến',
  }

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="swing-in-top-fwd modal-history"
    >
      <div className="modal-description">
        <h2>
          LỊCH SỬ NHẬN QUÀ
        </h2>

        <div className="history-wrapper">
          <table className="table-history table-header">
            <thead>
              <tr>
                <th style={{ width: '10%' }}>STT</th>
                <th style={{ width: '30%' }}>TÊN VẬT PHẨM</th>
                <th style={{ width: '20%' }}>NHẬN TỪ</th>
                <th style={{ width: '20%' }}>THỜI GIAN</th>
                <th style={{ width: '20%' }}>TRẠNG THÁI</th>
              </tr>
            </thead>
          </table>

          <Scrollbar style={{ height: '30vw' }} noScrollX={true}>
            <table className="table-history table-body">
              <tbody>
                {histories?.length > 0 ? histories?.map((his: any, index: number) => (
                  <tr key={index}>
                    <td style={{ width: '10%' }}>{index + 1}</td>
                    <td style={{ width: '30%' }}>
                      {his?.reward_name}
                    </td>
                    <td style={{ width: '20%' }}>{sourceMap[his?.usage as keyof typeof sourceMap]}</td>
                    <td style={{ width: '20%' }}>
                      <div className="time-col">
                        {his?.create_time?.split(' ').map((item: string, idx: number) => <div key={idx}>{item}</div>)}
                      </div>
                    </td>
                    <td style={{ width: '20%' }}>{his?.status}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={5} className="text-center">Chưa có lịch sử</td>
                  </tr>
                )}
              </tbody>
            </table>
          </Scrollbar>
        </div>
      </div>
      <a onClick={event => selfClose(event)} className="close" data-dismiss="modal" aria-label="Close">
        ×
      </a>
    </Modal>
  )
}
export default ModalHistory